import { render, staticRenderFns } from "./educational-platforms.vue?vue&type=template&id=213a2dc0&scoped=true&"
import script from "./educational-platforms.vue?vue&type=script&lang=js&"
export * from "./educational-platforms.vue?vue&type=script&lang=js&"
import style0 from "./educational-platforms.vue?vue&type=style&index=0&id=213a2dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213a2dc0",
  null
  
)

export default component.exports